import * as React from 'react';
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const ArgoScreenSizePopUpHook = (props) => {
    const loggedIn = useSelector(state => state.login.loggedIn);
    const showWelcomeMessage = useSelector(state => state.login.showWelcomeMessage);
    
    return(
        <React.Fragment>
        {window.screen.height >= 1080 && window.screen.width >= 1920 ? "" :
            <Dialog open={loggedIn &&
                showWelcomeMessage &&
                localStorage.getItem("hasSeenWelcomeMessage") === "false"} onClose={props.closeFunction}>
                <DialogTitle style={{color: "red"}}>Warning</DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>
                        This application was designed to operate with an available screen resolution of 1080 x 1920 or higher.
                        Adjust your screen resolution settings to view the application correctly.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closeFunction} color="primary">OK</Button>
                </DialogActions>
            </Dialog>
        }
        </React.Fragment>
    );
};

ArgoScreenSizePopUpHook.defaultProps = {
    closeFunction: null
};

ArgoScreenSizePopUpHook.propTypes = {
    closeFunction: PropTypes.func
};

export default ArgoScreenSizePopUpHook;

